import { BaseApiService } from '@shared/services/BaseApiService';

class PaymentServiceClass extends BaseApiService {
  constructor(opts) {
    super(opts);
  }

  createItem(params) {
    return this.http.post('/', params);
  }

  createRequest(params) {
    return this.http.post('/methods/invoice-request', params);
  }

  getAvailableMethods() {
    return this.http.get('/methods/available');
  }

  getConversions(params) {
    // params: amount&from&to;

    return this.pure_http.get('/conversions/convert', { params });

    // const response = {
    //   USD: {
    //     currency: params.to,
    //     amount: 78
    //   }
    // };
    // return new Promise((success) => {
    //   return success(response);
    // });
  }
}

export const PaymentService = new PaymentServiceClass({
  api_version: 2,
  resource: 'payments'
});
